import {
  DueDisplayOptions,
  GoalDeadlineRowsMap,
  ID,
  PrecomputedCompletion,
  Task,
  Timestamp,
} from '@griply/types';
import { createContext, useContext } from 'react';

export type MultipleDeadlinesRenderData = {
  tasksMap: Record<ID, Task>;
  tasks: Task[];
  today: Date;
  denseFormat?: boolean;
  defaultNewTaskDate?: Timestamp;
  goalId?: ID;
  lifeAreaId?: ID;
  tagId?: ID;
  displayDue?: DueDisplayOptions[];
  showRepeatingAsTodo?: boolean;
  completionData?: Record<string, PrecomputedCompletion>;
  overdueTasks: Task[];
  goalRenderData?: GoalDeadlineRowsMap;
};

export const MultipleDeadlinesRenderDataContext =
  createContext<MultipleDeadlinesRenderData | null>(null);

export const useMultipleDeadlinesRenderData =
  (): MultipleDeadlinesRenderData => {
    const data = useContext(MultipleDeadlinesRenderDataContext);
    if (!data) {
      throw new Error(
        'useMultipleDeadlinesRenderData must be used within a MultipleDeadlinesGroupTaskList',
      );
    }
    return data;
  };
